'use strict';

var $               = require('jquery');
var Core            = require('../core/core.js');
var InspectorImage = require('./inspector__image.js');

/**
 * Creates an inspector image group
 *
 * @class
 */

class InspectorSelectableImageGroup extends Core {
    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'title': '',
                'tooltip': '',
                'read_only': false
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class="editor__inspector__item editor__inspector__item__selectable__imagegroup">
                <% if(title) { %> 
                    <div class="editor__inspector__item__label" title="<%- tooltip %>"><%- title %></div> 
                <% } %>
                <div class="editor__inspector__item__selectable__imagegroup__container"></div>
            </div>
        `;

        super.render();

        if(options.fields['read_only']) {
            $('.editor__inspector__item__selectable__imagegroup__container', this.$el).addClass("editor__inspector__item__selectable__imagegroup__container--read__only");
        }
    }

    addImage(title, value, tooltip){
        return new InspectorImage({
            target: $('.editor__inspector__item__selectable__imagegroup__container', this.$el),
            fields: {
                'title': title,
                'value': value,
                'tooltip': tooltip
            }
        });
    }
}

module.exports = InspectorSelectableImageGroup;